module.exports = __webpack_public_path__ + "img/icon-groupe-positif.d41acd00.svg";